import { useCallback } from 'react'
import { IRowNode } from 'ag-grid-enterprise'
import { CustomReportVariable } from '../../../../redux/context/customReports/typesVariable'
// eslint-disable-next-line import/extensions, import/no-unresolved
import { TransposedRowData as GridRowData } from '../components/grid/utils/transposedRowData'

export interface UseRowFilteringReturn {
  isExternalFilterPresent: () => boolean
  doesExternalFilterPass: (node: IRowNode<GridRowData>) => boolean
}

/**
 * Hook to filter empty rows in custom reports when categories are rows
 * @param displayEmptyRows - Whether to display rows without data
 * @param variables - List of variables to check for data
 * @returns External filter functions for AG Grid
 */
export const useRowFilteringCategories = (
  displayEmptyRows: boolean,
  variables: CustomReportVariable[]
): UseRowFilteringReturn => {
  const isExternalFilterPresent = useCallback(() => {
    return !displayEmptyRows
  }, [displayEmptyRows])

  const doesExternalFilterPass = useCallback(
    (node: IRowNode<GridRowData>) => {
      if (!node.data) return false

      const { categoryId } = node.data

      // Check if any variable has a non-zero value for this category
      for (const variable of variables) {
        const balance = variable.balances?.find(b => b.groupId === categoryId)
        const value = balance?.value ?? 0

        if (!Number.isNaN(value) && value !== 0) {
          return true // Found at least one non-empty value
        }
      }

      // No non-zero values found, hide the row
      return false
    },
    [variables]
  )

  return {
    isExternalFilterPresent,
    doesExternalFilterPass
  }
}
